import { usePeopleFiltersContext } from '@sales-app/context/peopleFilters/peopleFilters'
import { PeopleQueries } from '@sales-app/graphql/queries/people.queries'
import { useDebounce } from '@shared/hooks'

import { useGraphql } from '@/hooks/useGraphql'

export const useBookablePersons = () => {
  const { bookablePersonType, searchString, includeDuplicates } = usePeopleFiltersContext()
  const debouncedSearch = useDebounce(searchString, 1000)
  const peopleQuery = useGraphql<PeopleQueries.GET_BOOKABLE_PERSONS.Response>(
    PeopleQueries.getBookablePeople.name,
    PeopleQueries.getBookablePeople(),
    { filter: { searchString: debouncedSearch, includeDuplicates, bookablePersonType } },
    { refetchOnMount: 'always' },
  )

  return peopleQuery
}
